import { UserFactory, } from '@haaretz/vanilla-user-utils';

export default function getUser() {
  const user = new UserFactory(true).build();
  user.type = user.type || user.userType;
  return user;
}
